/**
 * The public keys a licence's code is checked against (see lib/licence): the developer's, whose
 * private key never leaves the developer's machine (scripts/licence.ts). A key taken out stops
 * every code it signed from working.
 */
export const LICENCE_PUBLIC_KEYS: JsonWebKey[] = [
  // The developer's, made 2026-11-01.
  { kty: 'EC', crv: 'P-256', x: 'ylyPv7N1TvGD74Fficypo0SvoO5YMhf1RFb0vOLT94I', y: 'A7EPODTiJo_Vym_PjYH97iZl89ElhilCo3pKFCc6o9M' },
];
